import { SortingRule } from 'react-table';
import { SortDirection } from './types';

export const mapSortingRulesToValues = (sorted: SortingRule[]): string[] =>
  sorted.map(
    ({ id, desc }) => `${id},${desc ? SortDirection.DESC : SortDirection.ASC}`,
  );
